import { render, staticRenderFns } from "./PresentationPreviewModal.vue?vue&type=template&id=6d897ddd&scoped=true&"
import script from "./PresentationPreviewModal.vue?vue&type=script&lang=js&"
export * from "./PresentationPreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d897ddd",
  null
  
)

export default component.exports